// extracted by mini-css-extract-plugin
export default {"triggerInner":"S-Q7-","isDark":"_0fSLN","textContainer":"r-sKl","title":"nMILL","text":"mrEv8","arrow":"oZKhU","isOpen":"_2Uq78","skeleton-progress":"YZlmt"};